import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, Input, useToast} from "@chakra-ui/react";
import useFeedback from "../../utils/use_feedback";
import {useSaveFolders, useSaveToFolder, useUnsaveToFolder} from "../../api/save";
import RadioInputs from "../radio_inputs";
import useForm from "../../utils/use_form";
import {Header, Title} from './sheet';

const Folders = styled.div``;
const Folder = styled.div``;

const New = styled.div``;

const SaveSheet = styled(({className, post, comment, onClose}) => {

    const {error, busy, feedbackCh} = useFeedback();
    const type = post ? 'post' : 'comment';
    const id = type === 'post' ? post.id : comment.id;
    const folders = useSaveFolders(feedbackCh, type, id);

    const [newFolder, setNewFolder] = useState('');

    const toast = useToast();
    const save = useSaveToFolder(feedbackCh);
    const unsave = useUnsaveToFolder(feedbackCh);

    const [values, Provider] = useForm({folder: ""});

    const handleSave = async () => {

        if (values.folder === "" || (values.folder === "createNewFolder" && newFolder.length === 0)) return;

        const addingNew = values.folder === "createNewFolder";
        const existingFolder = !addingNew && JSON.parse(values.folder);
        try {
            const contains = !addingNew && existingFolder.contains;
            const folderName = addingNew ? newFolder : existingFolder.name;
            await contains ? unsave(id, post ? 'true' : 'false', folderName) :
                save(id, post ? 'true' : 'false', folderName);
            toast({
                title: `Post ${contains ? 'unsaved' : 'saved'}!`,
                status: 'success',
                isClosable: true,
            });
        } catch {
            toast({
                title: `Failed to save.`,
                status: 'error',
                isClosable: true,
            });
        }

        onClose();

    };

    return (
        <div className={className}>

            <Header>
                <Title>Save this {post ? 'post' : 'comment'}</Title>
            </Header>

            {values.folder === "createNewFolder" ?
                    <New>
                        <Input focusBorderColor={'none'} type="text" value={newFolder} onChange={(e) => setNewFolder(e.currentTarget.value)} placeholder="New folder" />
                    </New>
                :
                    <Folders>

                        <Provider>
                                <RadioInputs name="folder" childrenStyle={{marginBottom: 24}} labelStyle={{marginLeft: 8}}>
                                    {(folders ?? []).map((folder) => (
                                        <option value={JSON.stringify(folder)}>
                                            {folder.name}
                                        </option>
                                    ))}
                                    <option value="createNewFolder">
                                        Create new folder
                                    </option>
                                </RadioInputs>
                        </Provider>

                    </Folders>
            }

            <Button variant={"grey"} width={"100%"} mt={4} onClick={handleSave}>Save</Button>

        </div>
    );
})`
${Folder} {
  padding: 8px 16px;
  border-radius: 6px;
  margin-right: 8px;
  margin-bottom: 8px;
}
  ${Folders} {
    margin-top: 24px;
  }
label {
  font-size: 16px;
  font-weight: 400;
  padding: 0 8px;
}`;

export default SaveSheet;
